export const genres = ['Masculino', 'Feminino'];
